import React, { useState } from 'react';
import '../styles/navbar.css';
import { Link } from 'react-router-dom';
import AspireCTA from './AspireCTAComponent.js'; // Import the AspireCTA component

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div className="navbar">
      <div className="navbar-logo">
        <Link to="/"><img src="/images/aslLogo2026.png" alt="All Seasons Landscaping" className="navbar-logo-img" /></Link>
      </div>
      
      <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <ul className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
        <li className="nav-dropdown services-dropdown">
          <button className="dropdown-toggle">Services</button>
          <div className="dropdown-menu">
            <Link to="/LandscapeConstruction" onClick={() => setIsMenuOpen(false)}>Landscape Construction</Link>
            <Link to="/Maintenance" onClick={() => setIsMenuOpen(false)}>Maintenance</Link>
            <Link to="/WaterFeature" onClick={() => setIsMenuOpen(false)}>Water Solutions/Irrigation</Link>
            <Link to="/Snow" onClick={() => setIsMenuOpen(false)}>Snow Removal</Link>
            <Link to="/flower" onClick={() => setIsMenuOpen(false)}>Seasonal Flowers</Link>
             <Link to="/fencing" onClick={() => setIsMenuOpen(false)}>Fencing</Link>
            <Link to="/light" onClick={() => setIsMenuOpen(false)}>Holiday Lighting</Link>
          </div>
        </li>

        <li><Link to="/gallery" onClick={() => setIsMenuOpen(false)}>Gallery</Link></li>

        <li><Link to="/TreeFarm" onClick={() => setIsMenuOpen(false)}>Tree Farm</Link></li>

        <li className="nav-dropdown about-dropdown">
          <button className="dropdown-toggle">About Us</button>
          <div className="dropdown-menu">
            <Link to="/TeamPage" onClick={() => setIsMenuOpen(false)}>Team</Link>
            <Link to="/Testimonial" onClick={() => setIsMenuOpen(false)}>Testimonials</Link>
            <Link to="/TeamPage#positions" onClick={() => setIsMenuOpen(false)}>Careers</Link>
            <Link to="/Contact" onClick={() => setIsMenuOpen(false)}>Contact</Link>
          </div>
        </li>

        {/* Priority "More" dropdown - dynamically populated based on screen size */}
        <li className="nav-dropdown priority-more">
          <button className="dropdown-toggle">More</button>
          <div className="dropdown-menu">
            {/* Services section - only shown when Services is hidden */}
            <div className="more-services-section">
              <div className="dropdown-section-header">Services</div>
              <Link to="/LandscapeConstruction" onClick={() => setIsMenuOpen(false)}>Landscape Construction</Link>
              <Link to="/Maintenance" onClick={() => setIsMenuOpen(false)}>Maintenance</Link>
              <Link to="/fencing" onClick={() => setIsMenuOpen(false)}>Fencing</Link>
              <Link to="/WaterFeature" onClick={() => setIsMenuOpen(false)}>Water Features</Link>
              <Link to="/Snow" onClick={() => setIsMenuOpen(false)}>Snow Removal</Link>
              <Link to="/flower" onClick={() => setIsMenuOpen(false)}>Seasonal Flowers</Link>
              <Link to="/light" onClick={() => setIsMenuOpen(false)}>Holiday Lighting</Link>
            </div>

            {/* About Us section - always shown in More when More is visible */}
            <div className="more-about-section">
              <div className="dropdown-section-header">About Us</div>
              <Link to="/TeamPage" onClick={() => setIsMenuOpen(false)}>Team</Link>
               <Link to="/Testimonial" onClick={() => setIsMenuOpen(false)}>Testimonials</Link>
              <Link to="/TeamPage#positions" onClick={() => setIsMenuOpen(false)}>Careers</Link>
              <Link to="/Contact" onClick={() => setIsMenuOpen(false)}>Contact</Link>
            </div>
          </div>
        </li>

        {/* Client Portal Button */}
        <li onClick={() => setIsMenuOpen(false)}>
          <AspireCTA variant="navbar" />
        </li>
      </ul>
    </div>
  );
};

export default Navbar;